import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ConfigurationCriteriaContainer } from 'src/features/configuration/configurationCriteria/ConfigurationCriteriaContainer';
import { ConfigurationReferencesContainer } from 'src/features/configuration/configurationReferences/ConfigurationReferencesContainer';

export function Configuration(): ReactElement {
  const { t } = useTranslation('configuration');

  return (
    <div className='flex h-[calc(100vh-65px)] w-full flex-row gap-10 p-6'>
      <div className='relative flex h-full w-1/2 flex-col gap-4'>
        <span className='font-bold text-lg'>{t('References list')}</span>
        <ConfigurationReferencesContainer />
      </div>
      <div className='flex h-full w-1/2 flex-col gap-4'>
        <span className='font-bold text-lg'>{t('Criteria')}</span>
        <ConfigurationCriteriaContainer />
      </div>
    </div>
  );
}
